<script>
    import {
        getAsaItemCodeLabel,
        getCardiacAsaCodes,
        updateConsultItems,
    } from "../../../helpers/asaHelper.svelte";

    export let itemProps = {},
        defaultItems = [],
        selectedItems = [],
        updateItems = () => {};

    $: isCardiacEncounter = itemProps.billingType == 3;

    $: if (defaultItems.length) _syncDisplayItems();

    $: if (selectedConsultType) _syncPotentialItems();

    let displayItems = [],
        consultTypes = [],
        potentialItemsMap = new Map(),
        selectedConsultType = "";

    const handleSelectItem = (item) => {
        updateItems(updateConsultItems(item, selectedItems, itemProps));
    };

    const handleChangeConsultType = () => {
        if (!isCardiacEncounter) return;

        // Remove all items if Consult type changed for Cardiac encounter
        selectedItems = [];
        updateItems();
    };

    // HELPER FUNCTIONS
    const _syncDisplayItems = () => {
        defaultItems.map((item) => {
            if (
                !consultTypes.some(
                    (type) => type.value == item.infoRegion.toString(),
                )
            )
                _syncConsultTypes(item);

            const { infoRegion, itemCode } = item;

            if (!potentialItemsMap.has(infoRegion))
                potentialItemsMap.set(infoRegion, [itemCode]);
            else {
                const arr = potentialItemsMap.get(infoRegion);
                arr.push(itemCode);
                potentialItemsMap.set(infoRegion, arr);
            }
        });

        if (consultTypes.length == 1)
            selectedConsultType = consultTypes[0].value;
        else if (consultTypes.length)
            selectedConsultType = selectedItems.length
                ? _getSelectedConsultType()
                : (consultTypes.find((type) =>
                      isCardiacEncounter
                          ? type.value == "Anaesthesia" // For Cardiac Consult
                          : type.value == "Consultations",
                  )?.value ?? "");
    };

    const _syncConsultTypes = (item) => {
        if (isCardiacEncounter) {
            // For Cardiac Consult
            getCardiacAsaCodes().map((code) => {
                if (
                    !consultTypes.length ||
                    !consultTypes.some(
                        (type) => type.label == code.infoRegion.toString(),
                    )
                )
                    consultTypes.push({
                        value: code.infoRegion.toString(),
                        label: code.infoRegion.toString(),
                    });
            });
        } else {
            let restrictionArr = [];

            switch (itemProps.billingType) {
                case 0:
                    restrictionArr = ["Pre-anaesthesia"];
                    break;
                case 1:
                    restrictionArr = [
                        "Consultancy",
                        "Telehealth",
                        "Consultations",
                    ];
                    break;
                case 2:
                    restrictionArr = ["Pre-anaesthesia"];
                    break;
                default:
                    break;
            }

            if (restrictionArr.includes(item.infoRegion.toString()))
                consultTypes.push({
                    value: item.infoRegion.toString(),
                    label:
                        itemProps.billingType == 2
                            ? "Pre-labour Neuraxial"
                            : item.infoRegion.toString(),
                });
        }
    };

    const _syncPotentialItems = () => {
        let potentialItemCode = [];

        if (isCardiacEncounter) _getDisplayCardiacConsultItems();
        else {
            if (potentialItemsMap.has(selectedConsultType))
                potentialItemCode = potentialItemsMap.get(selectedConsultType);

            displayItems = _filterItems(potentialItemCode, selectedConsultType);
        }
    };

    const _getDisplayCardiacConsultItems = () => {
        const cardiacItems = getCardiacAsaCodes();

        displayItems = cardiacItems.filter(
            (item) => item.infoRegion == selectedConsultType,
        );
    };

    const _filterItems = (arr = [], infoRegion = "") => {
        if (!arr.length) return [];

        return defaultItems.filter(
            (item) =>
                arr.includes(item.itemCode) && item.infoRegion == infoRegion,
        );
    };

    const _getConsultTitle = (arr = []) => {
        if (arr.length != 1) return "";

        return arr[0].label;
    };

    const _getSelectedConsultType = () => {
        if (!isCardiacEncounter)
            return (
                consultTypes.find((type) => type.value == "Consultations")
                    ?.value ?? ""
            );

        const cardiacConsultTypeMap = new Map();

        const cardiacAsaConsults = getCardiacAsaCodes();

        cardiacAsaConsults.map((consult) => {
            if (!cardiacConsultTypeMap.has(consult.infoRegion))
                cardiacConsultTypeMap.set(consult.infoRegion, [
                    consult.itemCode,
                ]);
            else {
                const types = cardiacConsultTypeMap.get(consult.infoRegion);
                cardiacConsultTypeMap.set(consult.infoRegion, [
                    ...types,
                    consult.itemCode,
                ]);
            }
        });

        const targetConsultType = selectedItems
            .map(
                (item) =>
                    [...cardiacConsultTypeMap].find(([group, codes]) =>
                        codes.includes(item.itemCode),
                    )?.[0],
            )
            .find(Boolean);

        return (
            consultTypes.find((type) =>
                targetConsultType
                    ? type.value == targetConsultType.toString()
                    : type.value == "Anaesthesia",
            )?.value ?? ""
        );
    };
</script>

<div class="flex flex-col gap-y-2 border-2 rounded-md justify-center p-4">
    <div class="flex flex-1 items-center gap-x-2">
        <p class="w-auto min-w-[6rem] font-bold text-lg">
            {_getConsultTitle(consultTypes)} Consults
        </p>

        {#if !_getConsultTitle(consultTypes)}
            <select
                class="flex-1 select select-md select-bordered"
                bind:value={selectedConsultType}
                on:change={handleChangeConsultType}
            >
                {#each consultTypes as type}
                    <option value={type.value}>
                        {type.label}
                    </option>
                {/each}
            </select>
        {/if}
    </div>

    <div class="flex flex-1 flex-wrap gap-2">
        {#if !isCardiacEncounter}
            {#if selectedConsultType && selectedConsultType != "Telehealth"}
                <div class="flex flex-1 flex-wrap gap-2">
                    {#each displayItems as item}
                        <button
                            class={`btn btn-sm rounded rounded-full text-sm hover:btn-primary ${
                                selectedItems.some((itm) => itm.id == item.id)
                                    ? "btn-primary"
                                    : "btn-secondary"
                            }`}
                            on:click|preventDefault={() =>
                                handleSelectItem(item)}
                        >
                            {getAsaItemCodeLabel(item)}
                            {item.infoShortTitle}
                        </button>
                    {/each}
                </div>
            {:else}
                <div class="flex flex-col gap-y-2">
                    <p class="text-md text-secondary">Videoconference</p>

                    <div class="flex flex-1 flex-wrap gap-2">
                        {#each displayItems.filter((item) => item.infoSubRegion == "Videoconference") as item}
                            <button
                                class={`btn btn-sm rounded rounded-full text-sm hover:btn-primary ${
                                    selectedItems.some(
                                        (itm) => itm.id == item.id,
                                    )
                                        ? "btn-primary"
                                        : "btn-secondary"
                                }`}
                                on:click|preventDefault={() =>
                                    handleSelectItem(item)}
                            >
                                {getAsaItemCodeLabel(item)}
                                {item.infoShortTitle}
                            </button>
                        {/each}
                    </div>

                    <p class="text-md text-secondary">Telephone</p>

                    <div class="flex flex-1 flex-wrap gap-2">
                        {#each displayItems.filter((item) => item.infoSubRegion == "Telephone") as item}
                            <button
                                class={`btn btn-sm rounded rounded-full text-sm hover:btn-primary ${
                                    selectedItems.some(
                                        (itm) => itm.id == item.id,
                                    )
                                        ? "btn-primary"
                                        : "btn-secondary"
                                }`}
                                on:click|preventDefault={() =>
                                    handleSelectItem(item)}
                            >
                                {getAsaItemCodeLabel(item)}
                                {item.infoShortTitle}
                            </button>
                        {/each}
                    </div>
                </div>
            {/if}
        {:else}
            {#each displayItems as item}
                <button
                    class={`btn btn-sm rounded rounded-full text-xs hover:btn-primary ${selectedItems.some((itm) => itm.itemCode == item.itemCode) ? "btn-primary" : "btn-secondary"}`}
                    on:click|preventDefault={() => handleSelectItem(item)}
                >
                    {getAsaItemCodeLabel(item)}
                    {item.infoShortTitle}
                </button>
            {/each}
        {/if}
    </div>
</div>
